import type { LinkToCohortQuizSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-cohort-quiz';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToCohortQuiz: TemplateOnlyComponent<LinkToCohortQuizSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToCohortQuiz };
